export function getPublicImage(folder: string, imagePath?: string): string | null {
  if (!imagePath) return null;

  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // For relative paths, construct the S3 URL based on environment
  // Use staging bucket for dev and staging environments, production bucket as default
  const apiUrl = import.meta.env.VITE_API_URL || '';
  const isProduction = import.meta.env.PROD && !apiUrl.includes('apidev') && !apiUrl.includes('apistaging');

  const bucket = isProduction ? 'assetseu.gimmefy.ai' : 'assetsstagingeu.gimmefy.ai';
  return `https://s3.eu-west-1.amazonaws.com/${bucket}/${folder}/${imagePath}`;

}